import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
//services
import { MasterService } from '../../../services/master.service'
import { MessageService } from '../../../services/message.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
    protected message: string | null = null
    
    protected loading: boolean = false;
    
    protected resetPassForm = new FormGroup({
        email: new FormControl<string | null>(null, [Validators.required, Validators.email, Validators.minLength(5), Validators.maxLength(255), Validators.pattern(/^[a-z0-9\-_\.]+@[a-z0-9\-_\.]+\.[a-z]{2,4}$/)])
    })

    get email() { return this.resetPassForm.get('email') }

    constructor(private master: MasterService, private ms: MessageService) { }

    ngOnInit() {}
    
    /**
     * 
     */
    protected resetPassword() {
        this.master.post(`reset`, { email: this.resetPassForm.get('email').value }, res => {
            this.loading = false;
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: 'An unknown error occurred.' });
                return
            }

            if (res.status !== 200) {
                this.message = res.data.error
                this.ms.sendMessage("alert", { type: "warning", text: res.data.error })
                return
            }

            this.ms.sendMessage("alert", { type: "success", text: "We've emailed you a reset password link." })
            this.message = "We've emailed you a reset password link."
        })
    }
}
